import { OnboardingWizard } from './components/OnboardingWizard/OnboardingWizard.tsx';
import type { OnboardingModuleProps } from './types.ts';

export const OnboardingModule = ({ SubscriptionModule }: OnboardingModuleProps) => (
  <OnboardingWizard SubscriptionModule={SubscriptionModule} />
);
